import { Regions } from 'common/model/account/regions';
import { useSelector } from 'react-redux';
import { clientCurrentRegionSelector, resourcesSelector } from 'redux/selectors';

export const useGetCurrentMaxBotLink = (): string => {
    const region = useSelector(clientCurrentRegionSelector);
    const resources = useSelector(resourcesSelector());

    switch (region) {
        case Regions.JaNAO:
        case Regions.KurganskajaOblast:
        case Regions.OrenburgskajaOblast:
        case Regions.Surgut:
        case Regions.SverdlovskajaOblast:
        case Regions.TjumenskajaOblast:
            return resources.settings.frontSettings?.maxBotVostokLink ?? '';
        case Regions.NRIC:
            return resources.settings.frontSettings?.maxBotNricLink ?? '';
        default:
            return '';
    }
};

export const useGetCurrentMaxCscBotLink = (): string => {
    const region = useSelector(clientCurrentRegionSelector);
    const resources = useSelector(resourcesSelector());

    switch (region) {
        case Regions.JaNAO:
        case Regions.KurganskajaOblast:
        case Regions.OrenburgskajaOblast:
        case Regions.Surgut:
        case Regions.SverdlovskajaOblast:
        case Regions.TjumenskajaOblast:
            return resources.settings.frontSettings?.maxCscBotVostokLink ?? '';
        case Regions.NRIC:
            return resources.settings.frontSettings?.maxCscBotNricLink ?? '';
        default:
            return resources.settings.frontSettings?.maxCscBotVostokLink ?? '';
    }
};
